module.exports = "pegasus_template/assets/tech/header-image.jpg";